
import { fetchCollection } from '@/services/base'
import Transformer from '@/transformers/transformer'
import unitTransformer from '@/transformers/catalogs/services/unitMeasurement'
import familyTransformer from '@/transformers/catalogs/services/family'
import zoneTransformer from '@/transformers/catalogs/zones'
import fileTypeTransformer from '@/transformers/commons/fileType/'
import jobTypeTransformer from '@/transformers/sinister/jobType'
import supplyTypeTransformer from '@/transformers/catalogs/services/supplyType'

const fetchUnitsMeasurement = () =>
  fetchCollection('unit_measurement',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'name',
      useTransformer: unitTransformer
    })
const fetchStates = () =>
  fetchCollection('states',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'name',
      useTransformer: Transformer
    })

const fetchFamilies = () =>
  fetchCollection('family',
    {
      useStore: 'catalogs',
      urlGroup: 'catalogs/services',
      sortValue: 'name',
      useTransformer: familyTransformer
    })

const fetchZones = () =>
  fetchCollection('zones',
    {
      useStore: 'catalogs',
      urlGroup: 'catalogs',
      sortValue: 'name',
      useTransformer: zoneTransformer
    })
const fetchJobTypes = () =>
  fetchCollection('job_type',
    {
      useStore: 'catalogs',
      urlGroup: 'sinister',
      sortValue: 'name',
      useTransformer: jobTypeTransformer
    })

const fetchSupplyTypes = () =>
  fetchCollection('supply-type',
    {
      useStore: 'catalogs',
      urlGroup: 'catalogs/services',
      sortValue: 'name',
      useTransformer: supplyTypeTransformer
    })
const fetchFileTypes = () =>
  fetchCollection('file_type',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'name',
      useTransformer: fileTypeTransformer
    })
const fetchCasualtyFileTypes = () =>
  fetchCollection('affected',
    {
      useStore: 'catalogs',
      urlGroup: 'sinister/files-type',
      sortValue: 'name',
      useTransformer: fileTypeTransformer
    })

const fetchContactClassification = () =>
  fetchCollection('initial_contact_classification',
    {
      useStore: 'catalogs',
      urlGroup: 'commons',
      sortValue: 'sort_index'
    })

export default () => [
  fetchUnitsMeasurement(),
  fetchStates(),
  fetchFamilies(),
  // fetchDetails(),
  fetchZones(),
  fetchJobTypes(),
  // fetchClients(),
  fetchSupplyTypes(),
  fetchFileTypes(),
  fetchCasualtyFileTypes(),
  fetchContactClassification()
]
